module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-L-46.434ab9a3.png";